import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setSelectedFilename } from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './FilenameFilter.styles';

const FilenameFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const filenameSelected = useSelector(
    (state: ApplicationState) => state.reports.filenameSelected,
  );

  const importationsReport = useSelector(
    (state: ApplicationState) => state.companyReport.importationsReport,
  );

  const handleSelectedFilename = (filename: string) => {
    dispatch(
      setSelectedFilename({
        filenameSelected: filename,
      }),
    );
  };

  return (
    <Box marginTop={1}>
      <List dense>
        {Array.isArray(importationsReport) &&
          importationsReport.map((item) => (
            <ListItem key={item.nsu} button>
              <ListItemText
                primary={item.fileName}
                onClick={() => {
                  handleSelectedFilename(item.fileName);
                }}
                classes={{ root: classes.itemText }}
              />
              <ListItemSecondaryAction>
                <Radio
                  edge='end'
                  color='primary'
                  onChange={() => handleSelectedFilename(item.fileName)}
                  checked={filenameSelected === item.fileName}
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export { FilenameFilter };
export default FilenameFilter;
